<template>
  <div ref="containerRef">
    <div class="text-center">
      Showing
      <vf-link target="_blank" :to="src">
        {{ envLabel }}
      </vf-link>
    </div>
    <base-iframe
      ref="frameRef"
      class="m-a"
      :src
      :style="{ 'width': pxToRem(width), 'transform-origin': 'left top', ...frameConfig }"
    />
  </div>
</template>

<script setup lang="ts">
type FrameConfig = {
  height: string
  transform: string
}

type EnvMapping = {
  regex: RegExp
  label: string
}

const { width, src } = defineProps<{
  width: number
  src: string
}>()

const { width: windowWidth } = useWindowSize()

const containerRef = ref()
const frameRef = ref()
const frameConfig = reactive({} as FrameConfig)

const calculateWidth = () => Math.max(width, containerRef.value.clientWidth)

const recalculate = () => {
  const containerWidth = containerRef.value.clientWidth
  const scale = containerWidth / calculateWidth()
  frameConfig.height = `calc(100% / ${scale})`
  frameConfig.transform = `scale(${scale})`
}

defineExpose({
  frameRef
})

const envMapping: EnvMapping[] = [
  { regex: /localhost/, label: 'localhost' },
  { regex: /netlify\.app/, label: 'PR preview' },
  { regex: /dev/, label: 'dev' },
  { regex: /qa/, label: 'qa' },
  { regex: /preprod/, label: 'preprod' },
  { regex: /www/, label: 'production' },
]

const envLabel = envMapping.filter(({ regex }) => regex.test(src)).map(({ label }) => label)[0] || 'unknown host'

watch([() => width, windowWidth], recalculate)

onMounted(recalculate)
</script>
